import { render } from "./PagePosts.vue?vue&type=template&id=3908289c"
import script from "./PagePosts.vue?vue&type=script&lang=js"
export * from "./PagePosts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__